/** WORDING_FILES */
export const WORDING_FILES = {
  defaultWording: 'defaultWording',
  deWording: 'deWording',
};

/** TOKEN_STORAGE */
export const TOKEN_STORAGE = {
  memory: 'memory',
  session: 'session',
};
/** modules names */
 export const MODULES_NAMES = {
   centerHub: 'centerHub',
   app: 'app',
 };

 /** RED_WARNING_ICON */
 export const RED_WARNING_ICON = 'warning-triangle';

 /** RED_SUCCESS_ICON */
 export const RED_SUCCESS_ICON = 'success-red';

 /** LARGE_ICON */
 export const LARGE_ICON = 'large';

 /** TERTIARY_COLOR */
 export const TERTIARY_COLOR = 'tertiary';

 /** PRIMARY_COLOR */
 export const PRIMARY_COLOR = 'primary';

 /** RECTANGLE_SHAPE */
 export const RECTANGLE_SHAPE = 'rectangle';

 /** ALIGN_CENTER */
 export const ALIGN_CENTER = 'center';

 /**  FORM_FIELD_TYPE */
export enum FORM_FIELD_TYPE {
  HEADLINE = 'headline',
  SUBHEADLINE = 'subheadline',
  TEXT_INPUT = 'input.text',
  DATE = 'input.date',
  TIME = 'input.time',
  NUMBER = 'input.number',
  EMAIL = 'input.email',
  TEXT_AREA = 'textarea',
  SELECT = 'select',
  CHECKBOX = 'checkbox',
  RADIO = 'radiogroup',
  DOWNLOAD = 'download',
  SEPARATOR = 'separator',
  PARAGRAPH = 'paragraph',
}

/** INPUT_TYPE */
export enum INPUT_TYPE {
  EMAIL = 'email',
  NUMBER = 'number',
  TEXT = 'text',
  DATE = 'date',
}

/** FORM_DETAILS_PAGE_HEADER_ID */
export const FORM_DETAILS_PAGE_HEADER_ID = 'form-details-header';

/** CAPTCHA_ID */
export const CAPTCHA_ID = 'captcha';

/** CAPTCHA_AUT_ID */
export const CAPTCHA_AUT_ID = 'captcha-aut';
